module.exports = __webpack_public_path__ + "img/B5BBB5_3B4026_6E745D_5C6147-256px.75ec32c9.png";